import { ObjectFieldTemplateProps } from '@rjsf/utils';

export function ObjectFieldTemplate({ properties }: ObjectFieldTemplateProps) {
  // (evan.qi) By default, RJSF wraps the form fields in a fieldset element, which
  // does not respect flex. We override that here by wrapping the fields in a div.
  return <div>{properties.map((element) => element.content)}</div>;
}
